import PanelLayout from "src/Layout/PanelLayout";

export default function HomePage() {
  // console.log(process.env.PUBLIC_URL);
  return (
    <PanelLayout>
      
    </PanelLayout>
  )
}